
export const AppSettings = {

  appname: 'QRDELIVERY',//PROFILEQR//LOYALLOFEEDBACK//CUSTOMERQR//QRDELIVERY//QRTAKEAWAY//QRDINEIN//EMENU//EBILL/FEEDBACK



  // base_url: 'http://13.127.71.165:7005/',
  // base_url: 'http://200.1.50.102:8000/',
  //base_url: 'http://200.1.50.108:7006/',
  //base_url: 'https://apiemenu.renoinfo.in/',
  // base_url: 'http://200.1.50.113:7006/',

  // base_url: 'https://apibistrosuit.renoinfo.in/',
  //base_url: 'https://api.expresswala.com/',
  base_url: 'https://api.tuckerpos.com/',


  getproductdetailsbyemenuUrl: 'product/getproductdetailsbyemenu',

  getsalesdetailsbyebillUrl: 'report/getsalesdetailsbyebill',

  getquesiondetailsfeedbackUrl: 'feedback/getquesiondetailsfeedback',
  insertfeedbackUrl: 'feedback/insertfeedback',


  getproductdetailsbyqrmenuUrl: 'product/getproductdetailsbyqrmenu',

  insertcartproductUrl: 'cart/insertcartproduct',
  getcartdetailsUrl: 'cart/getcartdetails',
  setcartplacedUrl: 'cart/setcartplaced',
  insertcustomerrequestUrl: 'cart/insertcustomerrequest',



  getcustomer: 'cart/getcustomer',
  insertcustomer: 'cart/insertcustomer',
  checkcustomersignup: 'cart/checkcustomersignup',
  checkcustomerlogin: 'cart/checkcustomerlogin',
  getcustomerlogin: 'cart/getcustomerlogin',
  setcustomerlogin: 'cart/setcartcustomerlogin',
  getorderbycustomer: 'cart/getorderbycustomer',
  getorderbyorderidcustomer: 'cart/getorderbyorderidcustomer',


  // Customer Register
  checkcustomer: 'customerse/checkcustomerse',
  insertcustomerse: 'customerse/insertcustomerse',
  getcustomeres:'customerse/getcardpointsbyid',
  setcustomeres: 'customerse/setcustomerse',

  // Storecode 
  getstoresynccode: 'store/getaddons',
  checkaddons: 'store/checkaddons',
  // check
  insertQuestionmainUrl: 'question/insertquestionmain',
  getQuestionmainUrl: 'question/getquestionbysynccode',
  // questionchoicesdetails
  insertQuestionchoicesdetailsUrl: 'question/insertquestionchoicesdetails',
  getQuestionchoicesdetailsUrl: 'question/getquestionchoicesdetailsbyid',
  // feedbackmain
  insertFeedbackmainUrl: 'feedback/insertfeedbackmain',
  getFeedbackmainUrl: 'feedback/getfeedbackmainbyid',
  // feedbackdetails
  insertFeedbackdetailsUrl: 'feedback/insertfeedbackdetails',
  getFeedbackdetailsListUrl: 'feedback/getfeedbackdetailsbylistview',

  // QRCODE
    getQRCodeUrl: 'qrcode/getqrcode',

}


